export default {"src":"/_next/static/media/integrations-1.e43c9343.svg","height":121,"width":101,"blurWidth":0,"blurHeight":0};